import React from 'react';
import { useGNBContext } from '../ODGNBProvider';
import { useGlobalKeys } from '../../../hooks/useGlobalKeys';
export var ODGNBMenu = function (props) {
    var items = props.def.items;
    var factory = useGNBContext().factory;
    var globalKeys = useGlobalKeys(function () { return items.map(function (i) { return i.globalKey; }); });
    return React.createElement(React.Fragment, null, items.map(function (def, index) { return factory.renderMenuItem(globalKeys[index], def); }));
};
//# sourceMappingURL=ODGNBMenu.js.map